import { FC } from 'react';
import Link from 'next/link';
import styles from './ScrollCardItem.module.scss';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { hideImgOnError } from '@/helpers/helpers';

interface IScrollCardItem {
  bookAlias: string;
  externalId: number;
  title: string;
  authorFullName?: string;
}

const ScrollCardItem: FC<IScrollCardItem> = ({ bookAlias, externalId, title, authorFullName }) => {
  return (
    <div className={styles.scrollCardItem}>
      <div className={styles.scrollCardItem__itemImgWrap}>
        <Link prefetch={false} href={bookAlias} className={styles.scrollCardItem__itemImg}>
          <img className={styles.scrollCardItem__img} src={`${DEV_ABSOLUTE_URL}/covers/${externalId}.jpg`} alt="img" onError={hideImgOnError} width="76" height="110" />
        </Link>
      </div>
      {!!authorFullName && <div className={styles.scrollCardItem__itemAuthor}>{authorFullName}</div>}
      <Link prefetch={false} href={bookAlias} className={styles.scrollCardItem__itemTitle}>
        {title}
      </Link>
    </div>
  );
};
export default ScrollCardItem;
